import Vue from "vue";

Vue.component("announcement-banner", {
	props: {
		items: {
			type: Array,
			required: true,
			default: () => []
		},
		link: {
			type: String,
			default: "#"
		},
		speed: {
			type: Number,
			default: 18000
		},
		label: {
			type: String,
			default: "Announcement"
		},
		labelIcon: {
			type: String,
			default: "bullhorn"
		},
		minItems: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			hovered: false
		};
	},
	computed: {
		paused() {
			return this.hovered || this.items.length === 1;
		},
		displayItems() {
			const src = this.items || [];
			// 0 or 1 item: render as-is (single item stays paused/static).
			// Already at/above target: no duplication.
			if (src.length <= 1 || src.length >= this.minItems) {
				return src;
			}
			// 2..(minItems-1): repeat WHOLE copies until length >= minItems,
			// so every cycle is complete (no doubled item at the loop seam).
			const copies = Math.ceil(this.minItems / src.length);
			const result = [];
			for (let c = 0; c < copies; c++) {
				for (let j = 0; j < src.length; j++) {
					result.push(src[j]);
				}
			}
			return result;
		}
	},
	methods: {
		onMouseEnter() {
			this.hovered = true;
		},
		onMouseLeave() {
			this.hovered = false;
		},
		itemHref(item) {
			if (!item || item.id == null) {
				return this.link;
			}
			const base = this.link.replace(/\/+$/, "");
			return base + "/" + encodeURIComponent(item.id);
		}
	},
	template: `
		<div
			v-if="items && items.length"
			class="announcement-banner"
			role="region"
			aria-label="Announcements">
			<div class="announcement-banner__inner">
				<div class="announcement-banner__label" aria-hidden="true">
					<b-icon :icon="labelIcon" pack="fal" custom-size="mdi-18px" />
					<span class="announcement-banner__label-text">{{ label }}</span>
				</div>
				<div
					class="announcement-banner__marquee"
					@mouseenter="onMouseEnter"
					@mouseleave="onMouseLeave">
					<vue-marquee-slider
						id="announcement-marquee"
						:speed="speed"
						:paused="paused"
						:auto-width="true"
						:space="24">
						<a
							v-for="(item, i) in displayItems"
							:key="i"
							:href="itemHref(item)"
							class="announcement-banner__item">
							<b-icon :icon="item.icon" pack="fal" custom-size="mdi-18px" />
							<span class="announcement-banner__text">{{ item.text }}</span>
							<span class="announcement-banner__cta">{{ item.linkLabel }} &rarr;</span>
						</a>
					</vue-marquee-slider>
				</div>
			</div>
		</div>
	`
});
